import PropTypes from "prop-types";
import "../../style/mfca-dashboard.css";

// shared between donor and receiver dashboards. green segment = recovered share,
// amber base = remainder. inline svg keeps it dependency-free and easy to scale.
const MATCHED_COLOR = "#669d2e";
const UNMATCHED_COLOR = "#e0a030";

const RecoveryDonut = ({ rate }) => {
  const clamped = Math.max(0, Math.min(100, Number(rate) || 0));
  // floor (not round) so "100%" strictly means literal-100 — matches the backend's
  // floor semantic on acceptedPct/acceptanceRate. without this, 99.5% rounds up to
  // "100%" and contradicts the row sitting under "Donors Needing Attention".
  const display = Math.floor(clamped);
  return (
    <div className="recovery-donut-container">
      <svg viewBox="0 0 36 36" className="circular-progress">
        <path
          className="circle-bg"
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className="circle-segment"
          strokeDasharray="100, 100"
          style={{ stroke: UNMATCHED_COLOR }}
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        {clamped > 0 && (
          <path
            className="circle-segment"
            strokeDasharray={`${clamped}, 100`}
            style={{ stroke: MATCHED_COLOR }}
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        )}
      </svg>
      <span className="progress-text">{display}%</span>
    </div>
  );
};

RecoveryDonut.propTypes = {
  rate: PropTypes.number,
};

export default RecoveryDonut;
